'use strict';
angular.module('app')
.service('theme', function ($http)
{
    this.all = ['neutral'];
    this.current = 'neutral';

    this.changeTo = function(theme)
    {
        this.current = theme;
    };

    this.setAll = function(themes)
    {
        this.all = themes;
    };

    this.getUrl = function()
    {
        if (this.all[this.current] === undefined) {
            return this.all.neutral;
        } else {
            return this.all[this.current];
        }
    }

    this.preload = function()
    {
        angular.forEach(this.all, function(url, name)
        {
            if (name !== 'neutral') {
                $http.get(url);
            }
        });
    }
});
